'use strict';

const sportCategories = require('./sportCategories');
const sports = require('../constants/sports');

/**
 * Find the category from the sport type
 * @param {String} sport Sport'stype
 * @param {Boolean} [isDaily=false] if the activity is daily
 * @returns {String} category's name
 */
function getCategoryFromSport(sport, isDaily = false) {

  // Special case for walking activities
  // as walking can be daily or not we have to get the right category :
  // dailyCategory or walkingCategory
  if (sport === sports.WALKING) {
    return isDaily ? 'dailyCategory' : 'walkingCategory';
  }

  const category = sportCategories.find(category => category.types.includes(sport));

  if (!category) {
    return 'othersCategory';
  }

  return category.name;
}

module.exports = getCategoryFromSport;
